/**
 * Created by dushyantha on 10/12/16.
 */
'use strict';

(function () {
    angular
        .module('trainingSchedule')
        .component('trainingProgramDetails', {
            templateUrl: 'training-schedule/components/training-program-details.tpl.html',
            controller: function ($scope,EventManagerService,TrainingScheduleService,MessageService,PopupManager) {
                var vm  =  this;
                vm.isDatesDisabled = false;
                vm.isNoOfDatesDisabled = false;
                vm.model ={
                    searchDTO : {
                        trainerType:{trainerTypeCode:''},
                        fromDate : "",
                        toDate : "",
                        days : null,
                        crewId : null ,
                        crewType : {crewTypeCode:''},
                        excludePlannedCrew:false
                    }

                };

                vm.activeButton= function () {
                  vm.isActiveProgramDetails = !vm.isActiveProgramDetails;
                };

                vm.selectTrainingCategory = function(category){
                    category.isSelected = true;
                    vm.selectedCategory = category;
                    vm.loadTrainingPrograms({'category':category});
                };

                vm.assignedProgram = function (program) {
                    vm.assignedPrograms.push(program);

                    var index = vm.programDetails.indexOf(program);
                    if (index > -1) {
                        vm.programDetails.splice(index, 1);
                    }

                };

                vm.removeProgram = function(program){
                    vm.programDetails.push(program);
                    var index = vm.assignedPrograms.indexOf(program);
                    if (index > -1) {
                        vm.assignedPrograms.splice(index, 1);
                    }
                };

                function adaptProgramList() {
                    angular.forEach(vm.assignedPrograms, function (program) {
                        var index = vm.programDetails.indexOf(program);
                        if (index > -1) {
                            vm.programDetails.splice(index, 1);
                        }
                    });
                }

                vm.$onChanges = function (changeObj) {
                    if (changeObj.selectedRecord && changeObj.selectedRecord.currentValue && (changeObj.selectedRecord.currentValue != changeObj.selectedRecord.previousValue)) {
                       adaptSelectedRecord()
                    }
                };
                vm.addAllPrograms = function(){
                    vm.assignedPrograms = vm.programDetails;
                    vm.programDetails =[];
                };
                vm.removeAllPrograms = function () {
                    vm.programDetail = vm.assignedPrograms;
                    angular.forEach(vm.assignedPrograms, function (program) {
                            vm.programDetails.push(program);
                    });
                    vm.assignedPrograms=[];
                };
                vm.searchCrew= function () {
                	if(validateSearchDTO()){
                		vm.searchCrewList({'searchDTO':vm.model.searchDTO});
                    }
                };

                function validateSearchDTO(){
                	//if either from date or to date exist
                	if(!!vm.model.searchDTO.fromDate && (vm.model.searchDTO.toDate == null || vm.model.searchDTO.toDate === '') ){
                		MessageService.error("To Date Is Required.");
                		return false;
                	}else if(!!vm.model.searchDTO.toDate && (vm.model.searchDTO.fromDate == null || vm.model.searchDTO.fromDate === '') ){
                		MessageService.error("From Date Is Required.");
                		return false;
                	}else if(!!vm.model.searchDTO.fromDate && !!vm.model.searchDTO.toDate){
                		var from = moment(vm.model.searchDTO.fromDate, "DD/MM/YYYY");
                		var to = moment(vm.model.searchDTO.toDate, "DD/MM/YYYY");
                		if(!moment(from).isSameOrBefore(to)){
                			MessageService.error("From Date is After To Date.");
                			return false;
                		}
                		return true;
                	}
                	return true;
                }

                function updateDTO(){
                    return {
                       trainingSlotId:"",
                       version:"",
                       startDate:"",
                       startTime:"",
                       programId:"",
                       trainingSlotProgramId:"",
                       trainingProgramDetailId:"",
                       ignoreConflicts:false,
                       ignoreExpiries:false
                    }
                }
                function adaptSelectedRecord(){
                    angular.forEach(vm.selectedRecord.assignedTraineeDetail , function (crewType) {
                        crewType.isSelected= false;
                    });
                }
                vm.updateProgram = function () {
                    var request = [];
                    angular.forEach(vm.assignedPrograms, function(program){
                        if(program && program.trainingProgramDetailId){
                            var temp =updateDTO();
                            temp.trainingSlotId=vm.selectedRecord.trainingSlotId;
                            temp.version = vm.selectedRecord.trainingSlotVersion;
                            temp.startDate = vm.selectedRecord.fromDate;
                            temp.startTime = vm.selectedRecord.fromTime;
                            temp.programId = !!vm.selectedCategory ? vm.selectedCategory.trainingProgramId : vm.selectedRecord.trainingProgramId;
                            temp.trainingSlotProgramId = !!vm.selectedCategory ? vm.selectedCategory.trainingSlotPrgramId : vm.selectedRecord.trainingSlotId;
                            temp.trainingProgramDetailId =program.trainingProgramDetailId;
                            request.push(temp);
                        }
                    });
                    vm.onUpdateTrainingDetails({'updateDTO':request});
                };
                vm.selectAssignedCategory = function(index){
                  clearSelection();
                  vm.selectedRecord.assignedTraineeDetail[index].isSelected =true;
                  vm.selectedTrainerCategory = vm.selectedRecord.assignedTraineeDetail[index];

                };

              vm.selectAssignedTrainerCategory = function(index){
                clearSelection();
                vm.selectedRecord.assignedTrainerDetail[index].isSelected =true;
                vm.selectedTrainerCategory = vm.selectedRecord.assignedTrainerDetail[index];

              };

              function clearSelection(){
                angular.forEach(vm.selectedRecord.assignedTraineeDetail,function(category){
                  category.isSelected = false;
                });

                angular.forEach(vm.selectedRecord.assignedTrainerDetail,function(category){
                  category.isSelected = false;
                });
              }



               //when field change
                vm.changedAnyField = function(flag){
                	if(flag === 'fromDate' || flag === 'toDate'){
                		//if from date or to date is entered then disabled no of Dates field
                		if( !!vm.model.searchDTO.fromDate || !!vm.model.searchDTO.toDate){
                			vm.model.searchDTO.days = null;
                    		vm.isNoOfDatesDisabled = true;
                		}else{
                			vm.isNoOfDatesDisabled = false;
                		}
                		//if no of Dates field is entered disabled from date and to date
                	}else if(flag === 'noOfDates'){
                		if(!!vm.model.searchDTO.days){
                			vm.model.searchDTO.fromDate = '';
                    		vm.model.searchDTO.toDate = '';
                    		vm.isDatesDisabled = true;
                		}else{
                			vm.isDatesDisabled = false;
                		}
                	}
                };

                vm.addTrainerTrainee = function(crew){
                    vm.selectedCrew= crew;
                    if(vm.selectedTrainerCategory.crewTypeCode === undefined){
                        MessageService.warning(MessageService.MESSAGES.TRAINING_SCHEDULE.TRAINER_TRAINEE_NOT_SELECT);
                    }
                    else if(crew.crewTypeCode === vm.selectedTrainerCategory.crewTypeCode || crewHasSelectedTrainerType()){
                        var param ={};
                        param.trainingSlotId=vm.selectedRecord.trainingSlotId;
                        param.crewProfileId=crew.crewProfileId;
                        param.trainingProgramId=vm.selectedRecord.trainingProgramId;
                        param.assignDate=vm.selectedRecord.fromDate;
                        param.assignTime=vm.selectedRecord.fromTime;
                        param.assignAsCrewType=vm.selectedRecord.crewTypeCode;
                        param.ignoreCrewTypeWarning= false;
                        param.continueIllegal= false;
                        param.userConfirm= false;
                        param.assignAsCrewType= vm.selectedTrainerCategory.crewTypeCode;
                        param.trainerCode = crewHasSelectedTrainerType()? vm.selectedTrainerCategory.crewTypeCode: null;

                        vm.assignTrainerTrainee({'trainerTraineeDTO':param});
                    }
                    else{
                        var details = {
                            title: 'Confirmation',
                            messages: ["Crew types/Trainer types do not match. Do you wish to continue?"]
                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, onCloseConfirmBox);
                    }
                };

                function crewHasSelectedTrainerType(){
                  var isMatching = false;
                  angular.forEach(vm.selectedCrew.trainerCodes,function(trnType){
                    if(trnType.trainerTypeCode == vm.selectedTrainerCategory.crewTypeCode){
                          isMatching = true;
                    }
                  });
                  return isMatching;
                }

                vm.removeCrew = function (parent, child,assignedCrew) {
                    vm.removeCrewFromProgram({'removeDTO':{'parentID':parent,'childId':child,'assignedCrew':assignedCrew}})
                };

                vm.otherHubUnAssignClick = function (otherHub) {
                  MessageService.error("Crew Can be Unassigned from the parent hub ("+otherHub+") only");
                };

                vm.showExternalTraineesPopUp = function () {

                	 var details = { trainingSlotId : vm.selectedRecord.trainingSlotId };
                	 PopupManager.openModal('EXTERNAL_TRAINEES', details, onClodeExternalTraineeAddingPopup);

                	 function onClodeExternalTraineeAddingPopup(params) {
                         if (!!params) {
//                             var isContinueIllegal = false;
//                             var isUserConfirm = true;
//                             CrewingHelper.assignEditEvent(params.assignEventRequestParam, isContinueIllegal, isUserConfirm,
//                                 function (assignEventData) {
//                                     if (assignEventData.success) {
//                                         loadActualSchedule(false);
//                                         createLocalStorageVariable(params.assignEventRequestParam.crewId);
//                                         MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
//                                        // updateSelectedCrew([params.assignEventRequestParam.crewId]);
//                                     }
//                                 },
//                                 function (msg) {
//                                     MessageService.error(msg);
//                                 }
//                             );
                         }
                     }
                };


                function onCloseConfirmBox(params){
                  if(!!params) {
                    var param = {};
                    param.trainingSlotId = vm.selectedRecord.trainingSlotId;
                    param.crewProfileId = vm.selectedCrew.crewProfileId;
                    param.trainingProgramId = vm.selectedRecord.trainingProgramId;
                    param.assignDate = vm.selectedRecord.fromDate;
                    param.assignTime = vm.selectedRecord.fromTime;
                    param.continueIllegal = false;
                    param.userConfirm = true;
                    param.assignAsCrewType = vm.selectedCrew.crewTypeCode;
                    param.ignoreCrewTypeWarning = true;
                    param.trainerCode = crewHasSelectedTrainerType()? vm.selectedTrainerCategory.crewTypeCode: null;

                    vm.assignTrainerTrainee({'trainerTraineeDTO': param});
                  }
                }

            },
            bindings: {
                trainingSchedule :'<',
                selectedRecord:'=',
                isActiveProgramDetails:'=',
                selectedCrew:'=',
                trainingPrograms:'=',
                loadTrainingPrograms:'&',
                programDetails:'=',
                assignedPrograms:'=',
                onUpdateTrainingDetails:'&',
                trainerTypes:'<',
                crewTypes:'<',
                searchCrewList:'&',
                crewList:'=',
                selectedTrainerCategory:'=',
                assignTrainerTrainee:'&',
                removeCrewFromProgram:'&',
                activeTabIndex:'='
            }
        });
})();
